import { Injectable } from '@angular/core';
import { KerkimiParams } from '@core/interfaces/dto/params/kerkimi-params.interface';
import { BehaviorSubject, filter, map, Observable, Subject } from 'rxjs';
import { Kerkimi } from '../interfaces/models/kerkimi.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class KerkimiService {
  private baseUrl: string = 'kerkimi/';

  private _fullWordList$: BehaviorSubject<{ list: Kerkimi[], propagate: boolean } | undefined> = new BehaviorSubject<{ list: Kerkimi[], propagate: boolean } | undefined>(undefined);
  
  private _jumpWordID$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(private apiService: ApiService) { }

  get(params?: KerkimiParams) {
    return this.apiService.get<Kerkimi[]>(`${this.baseUrl}`, params);
  }

  getFullWordList(propagateOnly: boolean = true) {
    return this._fullWordList$.asObservable().pipe(
      filter((value) => (propagateOnly ? value?.propagate! : true)),
      map((value) => {
        return value ? value.list : undefined;
      })
    );
  }

  resetFullWordList() {
    this._fullWordList$.next(undefined);
  }

  setFullWordList(list: Kerkimi[], propagate: boolean = true) {
    this._fullWordList$.next({ list: list, propagate: propagate });
  }

  getJumpWordID() {
    return this._jumpWordID$.asObservable();
  }

  setJumpWordID(wordID: number) {
    this._jumpWordID$.next(wordID);
  }

}
